module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/aw-b478dded01c70ad2275c32a83c4f818d.svg";